import { CertificacionI } from "interfaces/Certificacion";
import { ReactNode } from "react";
import { Table } from "react-bootstrap";
import { CertificacionesRow } from "./CertificacionesRow";

interface Props {
  elementos: CertificacionI[];
  renderActions?: (elemento: CertificacionI) => ReactNode;
}

export const CertificacionesTable = ({
  elementos = [],
  renderActions,
}: Props) => {
  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>ID</th>
            <th>Nombre</th>
            <th>Descripción</th>
            {renderActions && <th className="text-center">Acciones</th>}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <CertificacionesRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={renderActions}
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={renderActions ? 9 : 8}
                className="text-center table-error-message"
              >
                <p>
                  <b>No hay planes de estudio para visualizar.</b> Para poder
                  visualizar planes de estudio debes <br /> seleccionar el botón
                  agregar «Nueva certificación»
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
};
